import { Controller } from "@hotwired/stimulus"

// Toggles visibility of a content target and rotates a chevron icon.
// Usage:
//   <div data-controller="collapsible">
//     <button data-action="collapsible#toggle">Toggle</button>
//     <svg data-collapsible-target="icon" class="transition-transform">...</svg>
//     <div data-collapsible-target="content">...</div>
//   </div>
export default class extends Controller {
  static targets = ["content", "icon"]

  toggle() {
    this.contentTarget.classList.toggle("hidden")
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180")
    }
  }
}
